// removed by extract-text-webpack-plugin
module.exports = {"icon":"kHyW6","linkActive":"itbaJ","bubble":"_2X7UR","heart":"DuflW"};